var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPazzle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195.6 122",
    style: {
      enableBackground: "new 0 0 195.6 122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#41B9C3;enable-background:new    ;}\n\t.st1{fill:none;stroke:#41B9C3;stroke-linecap:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.2,44.8l17.5,65.3C31.2,100,44.1,94,48.3,94c2.5,0,6.9,2.3,5,11.5c-1.9,9.2,6,14.5,10.2,16 c4.3,0.2,13.1-0.8,13.6-6.1c1.4-3.8,1.8-9.8-0.7-13.6c-2.5-3.1-6.5-9.9-2.7-12.1c7.2-4.4,22.8-3.2,30.4-2.2 c3.8-15.2,0.5-30-1.6-35.5c-1.7-3.5-5.4-1.8-7.1-0.6C87.3,59,79.2,57.6,76.1,56c-2.6-1.3-7.7-6-6.9-14.9C69.9,32.2,80,30.3,85,30.4 c9.2,1.9,10.8-1.4,10.4-3.3c-1.7-9.9-9.2-17.7-15.1-27L19.7,16.4C1.7,21.6-0.8,37.5,0.2,44.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.7,37.1c6.8-11.2,26.7-31.3,52.1-22 M169.8,15.1L166,8.3 M169.8,15.1l-6.1,3.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPazzle1);
export default __webpack_public_path__ + "static/media/pazzle1.7f96aa0054e7c829cc2b25069bffbcc0.svg";
export { ForwardRef as ReactComponent };